/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Language_And_Cultural_Studies26Inputs */

const en_cv_extract_form_enum_language_and_cultural_studies26 = /** @type {(inputs: Cv_Extract_Form_Enum_Language_And_Cultural_Studies26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language and Cultural Studies`)
};

const de_cv_extract_form_enum_language_and_cultural_studies26 = /** @type {(inputs: Cv_Extract_Form_Enum_Language_And_Cultural_Studies26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprach- und Kulturwissenschaften`)
};

/**
* | output |
* | --- |
* | "Language and Cultural Studies" |
*
* @param {Cv_Extract_Form_Enum_Language_And_Cultural_Studies26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_language_and_cultural_studies26 = /** @type {((inputs?: Cv_Extract_Form_Enum_Language_And_Cultural_Studies26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Language_And_Cultural_Studies26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_language_and_cultural_studies26(inputs)
	return en_cv_extract_form_enum_language_and_cultural_studies26(inputs)
});
export { cv_extract_form_enum_language_and_cultural_studies26 as "cv_extract_form_enum_LANGUAGE_AND_CULTURAL_STUDIES" }